import React, { useState } from 'react';
import './index.scss';
import InputBlock from '$/components/global/inputBlock';
import BixButton from '$/components/global/bixButton';

export interface IDomainListProps {
  domains: string;
  updateChanges: (value: string) => void;
}

const DomainList: React.FC<IDomainListProps> = props => {
  const { domains } = props;

  const [domainsString, setDomainList] = useState(domains);
  const [newDomainString, setNewDomainString] = useState('');

  const removeDomain = event => {
    const allDomains = domainsString.split(',');
    const filteredDomains = allDomains.filter(domain => domain !== event.target.id);
    setDomainList(filteredDomains.join(','));
    props.updateChanges(filteredDomains.join(','));
  };

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setNewDomainString(event.target.value);
  };

  const addDomain = () => {
    const allDomains = domainsString.split(',');
    allDomains.push(newDomainString);
    setDomainList(allDomains.join(','));
    props.updateChanges(allDomains.join(','));
  };

  return (
    <div>
      <InputBlock title="Existing Domains">
        <table id="domainList">
          <thead>
            <tr>
              <th className="domain-name-column">Domain</th>
              <th className="domain-remove-column">Remove</th>
            </tr>
          </thead>
          <tbody id="domainBody">
            {domainsString.split(',').map((domain, idx) => (
              <tr>
                <td>{domain} </td>
                <td className="td-center">
                  {idx !== 0 && <button id={domain} className="fa fa-minus-circle" onClick={removeDomain} />}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </InputBlock>
      <InputBlock title="Add Client Domain">
        <input type="text" id="newDomain" onChange={handleInputChange} />
        <BixButton onClick={addDomain}>Add</BixButton>
      </InputBlock>
    </div>
  );
};

export default DomainList;
